import { win } from './win';

export function getParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, '\\$&'); // eslint-disable-line
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const getQueryParams = (): { [paramName: string]: string } =>
  win.location?.search
    ?.slice(1)
    .split('&')
    .map((pair) => pair.split('='))
    ?.reduce(
      (prevParams, [param, value]) => ({
        ...prevParams,
        [param]: value,
      }),
      {}
    );
